import { memo } from 'react';
import { Grid } from '@mui/material';
import { FastField, Field, withFormik } from 'formik';
import * as Yup from 'yup';

import { TextField } from '../../../../components/formik/text-field';
import { isValidMobile, isValidNumbers } from 'utils/custom-validation';

const ContactFields: Array<{
    name: string;
    label: string;
    icon: any;
    disabled?: boolean;
    options?: Array<any>;
    ltr?: 'true' | 'false';
    maxLength?: number;
}> = [
    {
        name: 'phone',
        label: 'شماره موبایل',
        icon: <i className="fa-light fa-mobile" />,
        disabled: true,
        ltr: 'true',
        maxLength: 12,
    },
    {
        name: 'email',
        label: 'ایمیل',
        icon: <i className="fa-light fa-envelope" />,
        ltr: 'true',
        maxLength: 65,
    },
];

const ContactSchema = Yup.object().shape({
    email: Yup.string()
        .required('فیلد ایمیل الزامی است')
        .min(3, 'فیلد ایمیل باید حداقل 3 کاراکتر باشد')
        .max(64, 'فیلد ایمیل باید حداکثر 64 کاراکتر باشد')
        .email('فرمت ایمیل وارد شده صحیح نمی‌باشد'),

    phone: Yup.string()
        .required('فیلد شماره موبایل الزامی است')
        .length(11, 'فیلد شماره موبایل باید دقیقاً 11 کاراکتر باشد')
        .matches(isValidMobile, 'لطفا یک شماره موبایل معتبر وارد کنید'),
});

const ContactFormTemplate = memo(({ disabled, disableAutoFill = false }: any): JSX.Element => {
    return (
        <Grid container spacing={2}>
            {ContactFields.map((field) => (
                <Grid item xs={12} md={6} key={field.name}>
                    <FastField
                        disabled={disabled}
                        {...field}
                        component={TextField}
                        disableAutoFill={disableAutoFill}
                    />
                </Grid>
            ))}
        </Grid>
    );
});

const ContactForm = withFormik({
    mapPropsToValues: () => ({ name: '' }),
    validationSchema: ContactSchema,
    validateOnChange: false,
    validateOnBlur: true,
    handleSubmit: (values, { setSubmitting }) => {},
})(ContactFormTemplate);

export { ContactForm, ContactFormTemplate, ContactSchema, ContactFields };
